import {
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UnknownFieldExceptionClass;
function UnknownFieldException() {
  if (UnknownFieldExceptionClass === VOID) {
    class $ extends SerializationException() {
      static h1o(message) {
        var $this = this.m1o(message);
        captureStack($this, $this.g1o_1);
        return $this;
      }
      static n1o(index) {
        return this.h1o('An unknown field for index ' + index);
      }
    }
    initMetadataForClass($, 'UnknownFieldException');
    UnknownFieldExceptionClass = $;
  }
  return UnknownFieldExceptionClass;
}
function init_kotlinx_serialization_SerializationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.l1o_1);
}
var SerializationExceptionClass;
function SerializationException() {
  if (SerializationExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static o1o() {
        var $this = this.od();
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
      static m1o(message) {
        var $this = this.n2(message);
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
      static p1o(message, cause) {
        var $this = this.pd(message, cause);
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'SerializationException', $.o1o);
    SerializationExceptionClass = $;
  }
  return SerializationExceptionClass;
}
var MissingFieldExceptionClass;
function MissingFieldException() {
  if (MissingFieldExceptionClass === VOID) {
    class $ extends SerializationException() {
      static x1o(message, cause, missingFields, serialName) {
        var $this = this.p1o(message, cause);
        captureStack($this, $this.w1o_1);
        $this.u1o_1 = missingFields;
        $this.v1o_1 = serialName;
        return $this;
      }
      static y1o(missingFields, serialName) {
        var tmp0_message = missingFields.q2() === 1 ? "Field '" + missingFields.r2(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing";
        return this.x1o(tmp0_message, null, missingFields, serialName);
      }
      static z1o(missingField, serialName) {
        var tmp0_missingFields = listOf(missingField);
        var tmp1_message = "Field '" + missingField + "' is required for type with serial name '" + serialName + "', but it was missing";
        return this.x1o(tmp1_message, null, tmp0_missingFields, serialName);
      }
      a1p(newMessage) {
        return MissingFieldException().x1o(newMessage, this, this.u1o_1, this.v1o_1);
      }
    }
    initMetadataForClass($, 'MissingFieldException');
    MissingFieldExceptionClass = $;
  }
  return MissingFieldExceptionClass;
}
//region block: exports
export {
  MissingFieldException as MissingFieldException24tqif29emcmi,
  SerializationException as SerializationExceptioneqrdve3ts2n9,
  UnknownFieldException as UnknownFieldExceptiona60e3a6v1xqo,
};
//endregion

//# sourceMappingURL=SerializationExceptions.mjs.map
